import React from 'react';
import { motion } from 'framer-motion';
import { Bell, Search, Settings, User } from 'lucide-react';

const DashboardHeader: React.FC = () => {
  const iconVariants = {
    initial: { scale: 1 },
    hover: { scale: 1.1 }
  };

  return (
    <motion.div 
      className="p-4 border-b border-white/10 flex justify-between items-center bg-gradient-to-r from-background to-background/50"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="flex items-center space-x-2">
        <motion.div 
          className="w-8 h-8 bg-accent rounded-full flex items-center justify-center text-background font-bold"
          whileHover={{ rotate: 5 }}
        >
          D
        </motion.div>
        <span className="font-semibold">DetailerOS</span>
      </div>
      
      <div className="hidden md:flex items-center space-x-2 bg-white/5 px-3 py-1.5 rounded-lg">
        <Search size={16} className="text-white/50" />
        <input 
          type="text" 
          placeholder="Search clients..." 
          className="bg-transparent border-none focus:outline-none text-sm w-32"
        />
      </div>
      
      <div className="flex items-center space-x-3">
        <motion.button 
          className="w-8 h-8 rounded-full flex items-center justify-center bg-white/5 hover:bg-white/10"
          variants={iconVariants}
          initial="initial"
          whileHover="hover"
        >
          <Bell size={16} />
        </motion.button>
        <motion.button 
          className="w-8 h-8 rounded-full flex items-center justify-center bg-white/5 hover:bg-white/10"
          variants={iconVariants}
          initial="initial"
          whileHover="hover"
        >
          <Settings size={16} />
        </motion.button>
        <motion.button 
          className="w-8 h-8 rounded-full flex items-center justify-center bg-accent text-background"
          variants={iconVariants}
          initial="initial"
          whileHover="hover"
        >
          <User size={16} />
        </motion.button>
      </div>
    </motion.div>
  );
};

export default DashboardHeader;